import { ApiTosAcceptance } from "avvir";

import { AvvirEvent } from "type_aliases";

export type TosAcceptancesLoaded = AvvirEvent<typeof TOS_ACCEPTANCES_LOADED, ApiTosAcceptance[]>

const tosAcceptancesLoaded = (apiTosAcceptances: ApiTosAcceptance[]): TosAcceptancesLoaded => ({
  type: TOS_ACCEPTANCES_LOADED,
  payload: apiTosAcceptances,
});

export const TOS_ACCEPTANCES_LOADED = "tos_acceptances_loaded";

export default tosAcceptancesLoaded;
